import { render, staticRenderFns } from "./SpeciesSummaryChart.vue?vue&type=template&id=1852f8ce&"
import script from "./SpeciesSummaryChart.vue?vue&type=script&lang=js&"
export * from "./SpeciesSummaryChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports